import { useMutation } from "@apollo/client"
import { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store/app/hooks"
import { setOpenSnackbar } from "../../../store/features/snackbar/snackbarSlice"
import { getErrorsAsString } from "../../../utils/getErrorsAsString"
import { setCloseAlert } from "../../../store/features/alert/alertSlice"
import { TextField } from "@mui/material"
import { havePermissions } from "../../../utils/permissions"
import { graphql } from "../../../gql"
import useLang from "../../../hooks/useLang"

const UPDATE = graphql(`
  mutation UpdateOneFaqPriority(
    $data: FaqUpdateInput!
    $where: FaqWhereUniqueInput!
  ) {
    updateOneFaq(data: $data, where: $where) {
      id
      priority
    }
  }
`)

interface UpdateFaqPriorityProps {
  id: number
  priority: number
}

const UpdateFaqPriority = ({ id, priority }: UpdateFaqPriorityProps) => {
  const dispatch = useAppDispatch()
  const [value, setValue] = useState(String(priority))
  const { getText } = useLang()

  const [commit, { loading }] = useMutation(UPDATE, {
    update(cache, { data }) {
      const dataFaq = data?.updateOneFaq
      if (dataFaq) {
        cache.modify({
          id: cache.identify({
            __typename: "Faq",
            id: id,
          }),
          fields: {
            priority() {
              return dataFaq.priority ?? 0
            },
          },
        })
      }
    },
    onCompleted: () => {
      dispatch(
        setOpenSnackbar({
          message: getText("La priorité du faq a été modifié avec succès"),
          status: "success",
        }),
      )
    },
    onError: (err) => {
      dispatch(setCloseAlert())
      dispatch(
        setOpenSnackbar({
          message: getErrorsAsString(err),
          status: "error",
        }),
      )
      setValue(String(priority))
    },
  })

  useEffect(() => {
    setValue(String(priority))
  }, [priority])

  const handleBlur = () => {
    const num = Number(value)
    if (!isNaN(num) && num !== priority) {
      commit({
        variables: {
          where: { id },
          data: { priority: { set: Math.abs(num) } },
        },
      })
    }
  }

  if (!havePermissions(["faqs.change"])) {
    return <p>{priority}</p>
  }

  return (
    <TextField
      size="small"
      variant="outlined"
      value={value}
      type="number"
      onChange={(e) => setValue(e.target.value)}
      onBlur={handleBlur}
      disabled={loading}
      InputProps={{ sx: { width: 80 } }}
    />
  )
}

export default UpdateFaqPriority
